export const CS_LANG = {
    copyright_name:"Autorská práva",
    copyright:"© Copyright plan-b architekti. Všechna práva vyhrazena.",
    title:"Plan-b architekti",
    desc:"Architektonické studio sídlicí v Praze a Bratislavě.",
    projects:"Projekty",
    publications:"Publikace",
    contact:"Kontakt"
};
